import { EpimsBaseEntityDto } from './epim-base.dto';

export class CommunityDto extends EpimsBaseEntityDto {
  CommunityName: string;
  LgaId: string;
  SubscriptionUserId: string;
  SerialNo: string;
  Version: number;
}
